<template>
    <CardPage :section="3" :page="7" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Great job! You are now more aware of the different risks we face as trans folks. You’ve gained education and will continue to build skills
            throughout the rest of the app. You’ve earned another sticker!
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text" :imgClass="'shine'"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section3/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section3/complete', true);
            this.$store.set('section3/sticker@earned', true);
        }
    }
};
</script>
